import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Leaf } from 'lucide-react'
import { useLogin } from '../hooks/useLogin'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { AuthPageShell, AUTH_INPUT_CLASS } from '@/components/auth/AuthPageShell'

const Login = (): JSX.Element => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { login, error, isLoading } = useLogin()

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault()
    await login(email, password)
  }

  return (
    <AuthPageShell
      icon={<Leaf className="size-6" aria-hidden />}
      title="Welcome back"
      description="Sign in to monitor your gardens and devices."
      onSubmit={handleSubmit}
      error={error}
      isLoading={isLoading}
      submitIdleLabel="Sign in"
      submitLoadingLabel="Signing in…"
      footer={
        <p className="text-center text-base leading-relaxed text-zinc-300">
          No account?{' '}
          <Link
            to="/signup"
            className="font-semibold text-emerald-400 no-underline hover:text-emerald-300 hover:underline"
          >
            Create one
          </Link>
        </p>
      }
    >
      <div className="space-y-2">
        <Label htmlFor="email" className="text-sm font-medium text-zinc-200">
          Email
        </Label>
        <Input
          id="email"
          type="email"
          autoComplete="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={AUTH_INPUT_CLASS}
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="password" className="text-sm font-medium text-zinc-200">
          Password
        </Label>
        <Input
          id="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={AUTH_INPUT_CLASS}
          required
        />
      </div>
    </AuthPageShell>
  )
}

export default Login
